<template>
  <!-- Левая рейка (десктоп): логотип, те же вкладки, внизу - язык. В режиме
       редактора маршрута вкладки подменяются слотом override (инструменты). -->
  <nav :aria-label="$t('app.navLabel')" class="hidden md:flex shrink-0 w-[84px] flex-col items-center gap-1 py-3 bg-card border-r border-border z-40">
    <button type="button" class="mb-2 mt-1 active:translate-y-px" :aria-label="logoLabel" @click="$emit('logo')">
      <img :src="logo" alt="" class="w-10 h-10 rounded-xl border border-border shadow-ink-sm object-cover" />
    </button>
    <slot v-if="$slots.override" name="override" />
    <template v-else>
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="group flex flex-col items-center justify-center gap-1 w-[68px] py-1.5 text-[11px] font-medium rounded-lg transition-colors"
        :class="active === tab.key ? 'text-primary' : 'text-muted-foreground hover:text-foreground'"
        :aria-current="active === tab.key ? 'page' : undefined"
        @click="$emit('select', tab.key)"
      >
        <span
          class="relative flex items-center justify-center w-12 h-8 rounded-full transition-colors duration-150"
          :class="active === tab.key ? 'bg-primary/10' : 'group-hover:bg-accent'"
        >
          <component :is="tab.icon" class="w-5 h-5" aria-hidden="true" />
        <span v-if="badges?.[tab.key]" class="absolute -top-0.5 right-1 h-2.5 w-2.5 rounded-full bg-destructive ring-2 ring-card" aria-hidden="true" />
        <span v-if="badges?.[tab.key]" class="sr-only">{{ $t('notifications.unreadDot') }}</span>
        </span>
        <span class="text-center leading-tight">{{ tab.label }}</span>
      </button>
      <button type="button" class="group flex flex-col items-center justify-center gap-1 w-[68px] py-1.5 text-[11px] font-medium rounded-lg transition-colors text-muted-foreground hover:text-foreground" @click="$emit('feedback')">
        <span class="flex items-center justify-center w-12 h-8 rounded-full transition-colors duration-150 group-hover:bg-accent">
          <MessageSquare class="w-5 h-5" aria-hidden="true" />
        </span>
        <span class="text-center leading-tight">{{ $t('app.feedbackButton') }}</span>
      </button>
    </template>
    <div class="mt-auto"><slot name="bottom" /></div>
  </nav>
</template>

<script setup lang="ts">
import type { Component } from "vue";
import { MessageSquare } from "lucide-vue-next";
import type { TabKey } from "../../utils/navigation";

defineProps<{ active: TabKey; tabs: { key: TabKey; label: string; icon: Component }[]; badges?: Partial<Record<TabKey, boolean>>; logo: string; logoLabel: string }>();
defineEmits<{ (e: "select", key: TabKey): void; (e: "logo"): void; (e: "feedback"): void }>();
</script>
